'use client';
import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

interface Props {
  label: string;
  value: number;
  max: number;
  color: string;
  suffix: string;
  description: string;
}

export default function SignalScoreRing({ label, value, max, color, suffix, description }: Props) {
  const data = [
    { name: 'bg', value: max, fill: 'rgba(255,255,255,0.04)' },
    { name: 'score', value: value, fill: color },
  ];

  return (
    <div className="rounded-md bg-zinc-800/60 border border-white/5 p-2.5 flex flex-col items-center justify-center text-center relative" style={{ minHeight: 110 }}>
      <p className="text-xs font-mono text-zinc-200 font-bold uppercase tracking-widest absolute top-2.5">
        {label}
      </p>
      <div className="w-16 h-16 mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="65%"
            outerRadius="90%"
            barSize={5}
            data={data}
            startAngle={90}
            endAngle={-270}
          >
            <RadialBar dataKey="value" cornerRadius={3} background={false} />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex items-center justify-center" style={{ top: 22 }}>
          <span className="text-xl font-bold font-mono tabular-nums" style={{ color }}>
            {value}{suffix}
          </span>
        </div>
      </div>
      <p className="text-xs text-zinc-400 font-mono leading-tight absolute bottom-2 left-2 right-2 truncate">
        {description}
      </p>
    </div>
  );
}